import { render, staticRenderFns } from "./CardPreview.vue?vue&type=template&id=8589c21a&"
import script from "./CardPreview.vue?vue&type=script&lang=js&"
export * from "./CardPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports